import React, { Fragment } from 'react';
import './reset.css'
import Form from './components/Form/Form'
import Title from './components/Title/Title'

function App() {
  return (
    <Fragment>
      <Title/>
      <Form/>
    </Fragment>
  );
}

export default App;
